import styled from 'styled-components';

export const Container = styled.div`
  h1{
    font-size: 1.5em;
    margin-bottom: 16px;
  }
`;
